export default "__VITE_ASSET__CAusguPk__"